import { Form, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import './secciones.scss';

const SeccionCompareciente = ({ form }) => {
  return (
    <div>
      <Form form={form} layout="horizontal">
        <div className="container-datos">
          <Form.Item name="nombreComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ nombreComp: target.checked });
              }}>
              Nombre(s)
            </Checkbox>
          </Form.Item>
          <Form.Item name="primerApellidoComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ primerApellidoComp: target.checked });
              }}>
              Primer apellido
            </Checkbox>
          </Form.Item>
          <Form.Item name="segundoApellidoComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ segundoApellidoComp: target.checked });
              }}>
              Segundo apellido
            </Checkbox>
          </Form.Item>
          <Form.Item name="tipoAsociacionComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ tipoAsociacionComp: target.checked });
              }}>
              Tipo de asociacion
            </Checkbox>
          </Form.Item>
          <Form.Item name="sujetoObligadoComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ sujetoObligadoComp: target.checked });
              }}>
              Sujeto Obligado
            </Checkbox>
          </Form.Item>
          <Form.Item name="puestoComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ puestoComp: target.checked });
              }}>
              Puesto
            </Checkbox>
          </Form.Item>
          <Form.Item name="estadoCivilComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ estadoCivilComp: target.checked });
              }}>
              Estado civil
            </Checkbox>
          </Form.Item>
          <Form.Item name="edadComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ edadComp: target.checked });
              }}>
              Edad
            </Checkbox>
          </Form.Item>
          <Form.Item name="domicilioComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ domicilioComp: target.checked });
              }}>
              Domicilio
            </Checkbox>
          </Form.Item>
          <Form.Item name="ocupacionComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ ocupacionComp: target.checked });
              }}>
              Ocupación
            </Checkbox>
          </Form.Item>
          <Form.Item name="identificacionComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ identificacionComp: target.checked });
              }}>
              Identificación
            </Checkbox>
          </Form.Item>
          <Form.Item name="folioComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ folioComp: target.checked });
              }}>
              Folio de identificación
            </Checkbox>
          </Form.Item>
          <Form.Item name="expedidaComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ expedidaComp: target.checked });
              }}>
              Expedida por
            </Checkbox>
          </Form.Item>
          <Form.Item name="anversoComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ anversoComp: target.checked });
              }}>
              Identificación anverso
            </Checkbox>
          </Form.Item>
          <Form.Item name="reversoComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ reversoComp: target.checked });
              }}>
              Identificación reverso
            </Checkbox>
          </Form.Item>
          <Form.Item name="firmaComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ firmaComp: target.checked });
              }}>
              Firma
            </Checkbox>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default SeccionCompareciente;

SeccionCompareciente.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired
};
